<template>
  <el-select filterable v-model="displayValue" :multiple="multiple" placeholder="Select" :clearable="true" :disabled="disabled" v-loading="isLoading">
    <el-option v-for="classification in classificationList" :value="classification.id" :label="classification.description" :key="classification.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'rule-asset-classification',
  props: {
    value: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    },
    multiple: {
      default: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        return this.value
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  data () {
    return {
      classificationList: Array,
      isLoading: true,
      assetInRule: {
        id: 0,
        description: 'Select All Asset Classifications'
      }
    }
  },
  methods: {
    fetchClassificationList () {
      this.isLoading = true
      var call = '/getPEAFinancialAssetClassificationList'
      this.$axios.get(call).then(response => {
        this.classificationList = response.data
        this.classificationList.unshift(this.assetInRule)
        this.isLoading = false
      }).catch(reject => {
        this.isLoading = false
        if (this.$route.name === 'viewPEAApprovalRolesAndUsers') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent, 'Error getting Rule Division List', reject.body, 'error', 30000, '')
        } else {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent, 'Error getting Rule Division List', reject.body, 'error', 30000, '')
        }
      })
    }
  },
  created () {
    this.fetchClassificationList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
